export default __webpack_public_path__ + "static/media/lens-blue.f3194796.svg";